import { ArraySchema, Schema, type } from "@colyseus/schema"

import { CustomsClass } from "./customs"
import { CardDataClass } from "./сard"

export type PlayerState = null | "attacker" | "defender" | "thrower"

export type PlayerStatus = "online" | "offline" | "afk"

export class StatisticsClass extends Schema {
  @type("number") win: number
  @type("number") lose: number

  constructor(win = 0, lose = 0) {
    super()

    this.win = win
    this.lose = lose
  }
}

export class PaidFeaturesClass extends Schema {
  @type("boolean") cardHint!: boolean
}

export class PlayerClass extends Schema {
  @type("number") id!: number
  @type("number") coreId!: number

  @type("string") name!: string
  @type("string") username!: string
  @type("string") image!: string

  @type("number") balance!: number
  @type("number") balanceCurrency!: number
  @type("number") balanceDecimals!: number

  @type("number") bet!: number
  @type("number") betCurrency!: number
  @type("number") betDecimals!: number

  @type("number") specialBalance!: number
  @type("number") specialBalanceDecimals!: number

  @type(StatisticsClass) statistics = new StatisticsClass()
  @type(CustomsClass) customs = new CustomsClass()
  @type(["string"]) dignities = new ArraySchema<string>()
  @type(PaidFeaturesClass) paidFeatures = new PaidFeaturesClass()

  @type("number") lastPing!: number

  @type("string") sessionId!: string

  @type("number") coreSessionId!: number

  @type("boolean") isOwner!: boolean
}

export type Player = InstanceType<typeof PlayerClass>

export class PlayerDataClass extends Schema {
  @type(PlayerClass) info = new PlayerClass()

  @type("string") status!: PlayerStatus

  @type("boolean") ready!: boolean
  @type("boolean") playAgain?: boolean

  @type("number") lastActivity?: number

  @type("number") winAmount?: number

  @type("number") surrenderAt?: number
  @type("number") winAt?: number

  @type("string") playerState?: PlayerState

  @type([CardDataClass])
  cards = new ArraySchema<CardDataClass>()

  @type("boolean") isFirstGame?: boolean
  @type("number") referrerId?: number

  @type("number") cardsCount?: number

  @type("boolean") wantToTakeCards?: boolean

  @type("boolean") isSaidBeat?: boolean

  @type("boolean") needTimer?: boolean

  removeCard(card: CardDataClass) {
    if (!this.cards) throw new Error("Cards is undefined")

    const index = this.cards.findIndex((e) => {
      return e.cardSuit === card.cardSuit && e.cardPower === card.cardPower
    })

    if (index === -1) return

    this.cards.splice(index, 1)
  }

  addCard(card: CardDataClass) {
    if (!this.cards) throw new Error("Cards is undefined")

    this.cards.push(
      new CardDataClass(card.cardSuit, card.cardPower, this.info.customs.cards)
    )
  }
}

export type PlayerDataClassType = InstanceType<typeof PlayerDataClass>

export interface PlayerData {
  id: number
  name: string
  personalBetCurrency: number
  sessionId: string
  username?: string
}
